module.exports = __webpack_public_path__ + "static/img/kong-log.3fd51e85.png";